import React from "react";

import { filter, map, sortBy } from "lodash/fp";

import { Box, Skeleton } from "@mui/material";

import SettingsModule from "@app/analytics/account/components/SettingsModule";
import {
  SettingTitle,
  SettingSubtitle,
} from "@app/analytics/account/components/styles";
import { CenteredContainer } from "@app/analytics/auth/styles";
import ProviderButton from "@app/analytics/components/ProviderButton";
import useConnectedProviders from "@app/analytics/hooks/sso/useConnectedProviders";
import { ConnectedProvider } from "@app/common/auth/api";
import { SIGNUP_SSO_PROVIDERS } from "@app/common/constants/providers";
import { SSOProvider } from "@app/common/types/providerTypes";

import { Column } from "@rui/Stack";

const getAvailableAccountProviders = (
  connectedProviders: ConnectedProvider[]
): SSOProvider[] => {
  const connectedProviderIds = map("providerId", connectedProviders);
  const unconnectedProviders: SSOProvider[] = filter(
    (p) => !connectedProviderIds.includes(p.id),
    SIGNUP_SSO_PROVIDERS
  );
  return sortBy("displayName", unconnectedProviders);
};

const SingleSignOn = () => {
  const { connectedAccountProviders, addAccountProvider, isLoading } =
    useConnectedProviders();

  const availableAccountProviders = getAvailableAccountProviders(
    connectedAccountProviders
  );

  return (
    <>
      <Box
        sx={{
          bgcolor: "#F1F4FF",
          height: "100%",
          width: "100%",
          minHeight: "100vh",
          position: "absolute",
          zIndex: "-1",
        }}
      />
      <CenteredContainer>
        <Box sx={{ mb: "28px", width: { md: 518 } }}>
          <SettingsModule
            title="Single Sign-On"
            sx={{ overflow: "hidden", p: 3 }}
          >
            <SettingTitle>Add SSO Account</SettingTitle>
            <SettingSubtitle>
              Adding a single sign-on allows you to sign in to Read using the
              credentials associated with that account.
            </SettingSubtitle>
            {isLoading ? (
              <Skeleton variant="rounded" height="58px" />
            ) : (
              <Column spacing={2} variant="apart">
                {availableAccountProviders.map((config) => (
                  <ProviderButton
                    key={config.id}
                    icon={
                      <img
                        src={config.icon}
                        alt={`Sign up with ${config.displayName}`}
                      />
                    }
                    providerId={config.id}
                    onClick={() => addAccountProvider(config.id)}
                  >
                    Sign up with {config.displayName}
                  </ProviderButton>
                ))}
              </Column>
            )}
          </SettingsModule>
        </Box>
      </CenteredContainer>
    </>
  );
};

export default SingleSignOn;
